export default "__VITE_ASSET__wNaaa3BJ__"